import useSEO from "../hooks/useSEO";
import PageHero from "../components/PageHero";
import ServicesSection from "../components/ServicesSection";
import HowWeWork from "../components/HowWeWork";
import UseCases from "../components/UseCases";
import CTASection from "../components/CTASection";

export default function Services() {
  useSEO({
    title: "Services | SefKam Digital Solutions",
    description: "AI & intelligent automation, software engineering, digital transformation, and smart home automation from SefKam Digital Solutions.",
    path: "/services",
  });
  return (
    <>
      <PageHero
        eyebrow="Services"
        title="Technology solutions designed to solve real business problems."
        subtitle="From AI automation to cloud-native engineering, we build the systems that move your business forward."
      />
      <ServicesSection />
      <UseCases />
      <HowWeWork />
      <CTASection />
    </>
  );
}
